import React, { useEffect, useMemo, useState } from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { EASTERN_TZ_KEY, LAST_DATE_UPDATE_DATE_FORMAT } from '@/common/constants';

dayjs.extend(utc);
dayjs.extend(timezone);
interface Props {
  value?: Dayjs | null;
  testId?: string;
  isWideMode?: boolean;
  isLoading?: boolean;
  children?: React.ReactNode;
}

const ReportLastUpdateDate: React.FC<Props> = ({
  testId = 'last-update-date',
  value,
  isWideMode,
  isLoading,
  children,
}) => {
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (value && value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value, currentValue]);
  const formattedData = useMemo(() => {
    if (currentValue) {
      return currentValue.tz(EASTERN_TZ_KEY);
    }
    return null;
  }, [currentValue]);
  if (isLoading && !formattedData) {
    return (
      <div>
        <Box margin={{ top: 'spacing8' }} width="100%" direction="row" align="center" pad={{ left: '40px' }}>
          <Box data-testid={`${testId}_loading`} height="24px">
            <ShimmerBox round="container2Round" width="250px" />
          </Box>
          {children}
        </Box>
      </div>
    );
  }
  if (!formattedData) {
    if (children) {
      return (
        <div>
          <Box
            margin={{ top: 'spacing8' }}
            width="100%"
            direction="row"
            align="center"
            pad={{ left: '40px' }}
          >
            {children}
          </Box>
        </div>
      );
    }
    return null;
  }

  return (
    <div>
      <Box pad={{ left: '40px' }} direction="row" align="center" width="100%">
        <Box align="center">
          <Text color="textSecondary" data-testid={`${testId}`}>
            Last updated at {formattedData.format(LAST_DATE_UPDATE_DATE_FORMAT)}
          </Text>
        </Box>
        {children}
      </Box>
    </div>
  );
};

export default ReportLastUpdateDate;
